// Mock data for the English Academy website
export const mockData = {
  // Hero Section
  hero: {
    en: {
      tagline: "Canada English Life Academy Since 2017",
      title: "Learn English Online with",
      subtitle: "Canada English Life",
      description: "Comprehensive online English courses for everyone who wants to master English - for children and adults",
      cta: "Browse Our Courses"
    },
    ar: {
      tagline: "أكاديمية كندا للحياة الإنجليزية منذ 2017",
      title: "تعلم الإنجليزية عن بعد مع",
      subtitle: "معهد الحياة الإنجليزية الكندي",
      description: "دورات انجليزي اون لاين شاملة لمن يشاء أن يتقن الإنجليزية للصغار والكبار",
      cta: "تصفح دوراتنا"
    }
  },

  // Courses
  courses: [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800&q=80",
      title: { en: "Private Lessons with Foreign Teachers", ar: "دروس خصوصية مع معلمين أجانب" },
      description: {
        en: "One-on-one private lessons with native English teachers from USA, Canada, and UK. Choose 2 or 4 sessions per week. Half-hour sessions with flexible scheduling. All sessions are recorded and saved in your account for later reference.",
        ar: "دروس خصوصية فردية مع معلمين أصليين من أمريكا وكندا وبريطانيا. اختر جلستين أو 4 جلسات في الأسبوع. كل جلسة نصف ساعة مع جدول مرن يناسب احتياجاتك. جميع الجلسات مسجلة ومحفوظة في حسابك للرجوع إليها لاحقاً."
      },
      features: {
        en: ["Native speakers from USA, Canada, UK", "Flexible schedule", "Recorded sessions", "Half-hour per session"],
        ar: ["معلمين أصليين من أمريكا وكندا وبريطانيا", "جدول مرن", "جلسات مسجلة", "نصف ساعة لكل جلسة"]
      },
      price: { current: 350, original: 600, currency: { en: "SR", ar: "ر.س" } },
      priceNote: { en: "2 sessions/week for 1 month (650 SR for 4 sessions/week)", ar: "جلستين/أسبوع لمدة شهر (650 ر.س لـ 4 جلسات/أسبوع)" },
      discount: 42
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80",
      title: { en: "Adults Course - 5 Months Membership", ar: "عرض الكبار - 5 أشهر" },
      description: {
        en: "Comprehensive English course for adults. 4 sessions per week for 5 months, each session lasting one hour. American, Canadian, and British teachers using the internationally accredited American Language Center (Macmillan) curriculum.",
        ar: "دورة إنجليزية شاملة للكبار. 4 حصص في الأسبوع لمدة 5 أشهر، كل حصة مدتها ساعة واحدة. معلمين أمريكيين وكنديين وبريطانيين باستخدام منهج المركز الأمريكي للغات المعتمد دولياً."
      },
      features: {
        en: ["4 sessions per week", "1 hour per session", "5 months duration", "Live + Recorded sessions", "PDF materials included"],
        ar: ["4 حصص في الأسبوع", "ساعة واحدة لكل حصة", "مدة 5 أشهر", "حصص مباشرة ومسجلة", "مواد PDF مشمولة"]
      },
      price: { current: 600, original: 1500, currency: { en: "SR", ar: "ر.س" } },
      priceNote: { en: "Includes live & recorded sessions + PDF materials", ar: "يشمل الحصص المباشرة والمسجلة + مواد PDF" },
      discount: 60
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80",
      title: { en: "Children & Teens Course (Ages 3-18)", ar: "عرض الصغار واليافعين (3-18 سنة)" },
      description: {
        en: "Complete English course for children and teens ages 3 to 18 years. 4 days per week for 3 months, 45 minutes to 1 hour per session. Covers conversation, grammar, listening, writing, pronunciation, and reading - a comprehensive course in all language skills.",
        ar: "دورة إنجليزية شاملة للصغار واليافعين من سن 3 إلى 18 سنة. 4 أيام في الأسبوع لمدة 3 أشهر، من 45 دقيقة إلى ساعة لكل حصة. تشمل المحادثة والقواعد والاستماع والكتابة والنطق والقراءة - دورة شاملة في جميع مهارات اللغة."
      },
      features: {
        en: ["Ages 3-18 years", "4 days per week", "3 months duration", "All language skills", "Native teachers from USA, UK, Canada"],
        ar: ["الأعمار 3-18 سنة", "4 أيام في الأسبوع", "مدة 3 أشهر", "جميع مهارات اللغة", "معلمين أصليين من أمريكا وبريطانيا وكندا"]
      },
      price: { current: 600, original: 1499, currency: { en: "SR", ar: "ر.س" } },
      priceNote: { en: "Conversation, grammar, listening, writing, pronunciation, reading", ar: "محادثة، قواعد، استماع، كتابة، نطق، قراءة" },
      discount: 60
    },
    {
      id: 4,
      image: "https://images.unsplash.com/photo-1503676382389-4809596d5290?w=800&q=80",
      title: { en: "Foundation Course - 1 Month", ar: "دورة التأسيس - شهر واحد" },
      description: {
        en: "Foundation course covering letters, words, and numbers. 4 sessions per week for one month, 45 minutes to 1 hour per session. Choose between groups with foreign instructors or Arab instructors. Specialized teachers from USA, Canada, UK, plus Lebanese instructor.",
        ar: "دورة التأسيس تشمل الحروف والكلمات والأرقام. 4 حصص في الأسبوع لمدة شهر واحد، من 45 دقيقة إلى ساعة لكل حصة. اختر بين مجموعات مع معلمين أجانب أو معلمين عرب. معلمين متخصصين من أمريكا وكندا وبريطانيا، بالإضافة إلى معلم لبناني."
      },
      features: {
        en: ["Letters, words, numbers", "4 sessions per week", "Choose foreign or Arab instructors", "Live + Recorded sessions", "PDF curriculum included"],
        ar: ["الحروف والكلمات والأرقام", "4 حصص في الأسبوع", "اختر معلمين أجانب أو عرب", "حصص مباشرة ومسجلة", "المنهج PDF مشمول"]
      },
      price: { current: 150, original: 400, currency: { en: "SR", ar: "ر.س" } },
      priceNote: { en: "4-month package: 500 SR (instead of 600 SR)", ar: "باقة 4 أشهر: 500 ر.س (بدلاً من 600 ر.س)" },
      discount: 63
    },
    {
      id: 5,
      image: "https://images.unsplash.com/photo-1544717305-2782549b5136?w=800&q=80",
      title: { en: "Foundation Course - 4 Months Package", ar: "دورة التأسيس - باقة 4 أشهر" },
      description: {
        en: "Complete foundation package for 4 months. Same comprehensive curriculum covering letters, words, and numbers with specialized instructors. Best value with live and recorded sessions plus PDF materials.",
        ar: "باقة التأسيس الكاملة لمدة 4 أشهر. نفس المنهج الشامل للحروف والكلمات والأرقام مع معلمين متخصصين. أفضل قيمة مع الحصص المباشرة والمسجلة بالإضافة إلى مواد PDF."
      },
      features: {
        en: ["4 months complete package", "Save 100 SR", "Letters, words, numbers", "Live + Recorded sessions", "PDF curriculum included"],
        ar: ["باقة 4 أشهر كاملة", "وفر 100 ر.س", "الحروف والكلمات والأرقام", "حصص مباشرة ومسجلة", "المنهج PDF مشمول"]
      },
      price: { current: 500, original: 600, currency: { en: "SR", ar: "ر.س" } },
      priceNote: { en: "Best value - Save 100 SR!", ar: "أفضل قيمة - وفر 100 ر.س!" },
      discount: 17
    },
    {
      id: 6,
      image: "https://images.unsplash.com/photo-1517842645767-c639042777db?w=800&q=80",
      title: { en: "IELTS Preparation Course", ar: "دورة الآيلتس" },
      description: {
        en: "Intensive IELTS exam preparation course. Training includes solving sample questions similar to actual exam questions to achieve the highest score. Specialized native-speaking instructors from America and Britain.",
        ar: "دورة تحضيرية مكثفة لاختبار الآيلتس. يتضمن التدريب حل نماذج أسئلة مشابهة لأسئلة الاختبار للحصول على أعلى درجة في الاختبار. معلمين متخصصين من أمريكا وبريطانيا. ناطقين أصليين."
      },
      features: {
        en: ["IELTS exam training", "Practice with real exam questions", "Native speakers from USA & UK", "Individual course", "1 month duration"],
        ar: ["تدريب على اختبار الآيلتس", "تدرب على أسئلة حقيقية", "ناطقين أصليين من أمريكا وبريطانيا", "دورة فردية", "مدة شهر واحد"]
      },
      price: { current: 400, original: 800, currency: { en: "SR", ar: "ر.س" } },
      priceNote: { en: "Individual course - 1 month", ar: "دورة فردية - شهر واحد" },
      discount: 50
    }
  ],

  // Course Categories
  categories: [
    {
      id: 1,
      title: { en: "IELTS English Courses", ar: "دورات الآيلتس" },
      image: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=800&q=80"
    },
    {
      id: 2,
      title: { en: "Children English Courses", ar: "دورات الإنجليزية للأطفال" },
      image: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80"
    },
    {
      id: 3,
      title: { en: "Adults English Courses", ar: "دورات الإنجليزية للكبار" },
      image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80"
    },
    {
      id: 4,
      title: { en: "Individual One on One English Courses", ar: "دورات فردية" },
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80"
    }
  ],

  // Teachers
  teachers: [
    {
      id: 1,
      name: "Ms. Gaby",
      title: { en: "English Teacher", ar: "معلمة لغة إنجليزية" },
      image: "https://customer-assets.emergentagent.com/job_canada-arabic/artifacts/ezj5zlio_67e1e3c47c1020b19dd492a8.png",
      videoUrl: "https://youtu.be/pKzY7XUsJ6k",
      bio: {
        en: "Experienced English teacher with 8+ years of teaching. Specialized in conversational English and IELTS preparation.",
        ar: "معلمة لغة إنجليزية ذات خبرة تزيد عن 8 سنوات. متخصصة في الإنجليزية المحادثة وإعداد الآيلتس."
      },
      bookingUrl: "https://link.content-presence.com/widget/bookings/gaby-meeting"
    },
    {
      id: 2,
      name: "Mr. Brian",
      title: { en: "IELTS Trainer", ar: "مدرب الآيلتس" },
      image: "https://customer-assets.emergentagent.com/job_canada-arabic/artifacts/4e54r02s_67e1be350fc794a2b9d79bbd.png",
      videoUrl: "https://www.youtube.com/watch?v=-OTyPJCGxrQ",
      bio: {
        en: "IELTS expert with proven track record of helping students achieve 7+ band scores.",
        ar: "خبير الآيلتس مع سجل حافل في مساعدة الطلاب على تحقيق درجات 7+ في الاختبار."
      },
      bookingUrl: "https://link.content-presence.com/widget/bookings/b-instructor4evpkhrian"
    },
    {
      id: 3,
      name: "Ms. Katherine",
      title: { en: "Kids English", ar: "إنجليزية الأطفال" },
      image: "https://customer-assets.emergentagent.com/job_canada-arabic/artifacts/oomltj4t_67e1be441870f44ca939e77d.png",
      videoUrl: "https://www.youtube.com/watch?v=jMiwQKhsVfM",
      bio: {
        en: "Passionate about teaching young learners. Makes learning fun and engaging for children.",
        ar: "شغوفة بتعليم الأطفال. تجعل التعلم ممتعاً وجذاباً للأطفال."
      },
      bookingUrl: "https://link.content-presence.com/widget/booking/xSYRXzV7QyYra5ITZOSG"
    },
    {
      id: 4,
      name: "Mr. Jafar",
      title: { en: "Level 1 English", ar: "المستوى الأول" },
      image: "https://customer-assets.emergentagent.com/job_canada-arabic/artifacts/ij6tmfcs_67e1c2c60fc7940d17d7a2ee.png",
      videoUrl: "https://youtu.be/dKnAhU3BbUI",
      bio: {
        en: "Specializes in beginner level English. Patient and supportive teaching approach.",
        ar: "متخصص في المستوى الأساسي للغة الإنجليزية. نهج تدريسي صبور وداعم."
      },
      bookingUrl: "https://link.content-presence.com/widget/bookings/gaby-meeting"
    },
    {
      id: 5,
      name: "Ms. Layla",
      title: { en: "Beginner English Teacher", ar: "معلمة المبتدئين" },
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80",
      videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ", // Replace with actual teacher video
      bio: {
        en: "Helps beginners build confidence in English. Focus on practical communication skills.",
        ar: "تساعد المبتدئين على بناء الثقة في اللغة الإنجليزية. التركيز على مهارات التواصل العملية."
      },
      bookingUrl: "https://link.content-presence.com/widget/bookings/gaby-meeting"
    },
    {
      id: 6,
      name: "Ms. Henderina",
      title: { en: "Business English Instructor", ar: "مدرسة الإنجليزية للأعمال" },
      image: "https://customer-assets.emergentagent.com/job_canada-arabic/artifacts/ryhfsqx9_67e1be7f9643c113015e53b8.jpeg",
      videoUrl: "https://youtu.be/fm8_IC6_HCQ",
      bio: {
        en: "Business English expert. Helps professionals improve workplace communication.",
        ar: "خبيرة في الإنجليزية للأعمال. تساعد المحترفين على تحسين التواصل في مكان العمل."
      },
      bookingUrl: "https://link.content-presence.com/widget/bookings/gaby-meeting"
    }
  ],

  // Course Types
  courseTypes: [
    {
      id: 1,
      title: { en: "Groups Adult English Courses", ar: "دورات مجموعات انجليزي للكبار" },
      subtitle: { en: "(All Levels)", ar: "(جميع المستويات)" },
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80"
    },
    {
      id: 2,
      title: { en: "Groups Children English Courses", ar: "دورات مجموعات انجليزي للصغار" },
      subtitle: { en: "(All Levels)", ar: "(جميع المستويات)" },
      image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80"
    },
    {
      id: 3,
      title: { en: "Individual - One-on-One Classes", ar: "دورات فردية لجميع الأعمار" },
      subtitle: { en: "(All Levels)", ar: "(جميع المستويات)" },
      image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&q=80"
    },
    {
      id: 4,
      title: { en: "Individual - One-on-One Classes", ar: "دورات لتمهيد لاختبار الايلتس" },
      subtitle: { en: "(IELTS English Course)", ar: "(دورة الآيلتس)" },
      image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80"
    }
  ],

  // Testimonials
  testimonials: [
    {
      id: 1,
      name: "Eiman",
      text: {
        en: "If we had the same teacher competence, communication strength with students, and exciting teaching methods for both adults and children, our children would have learned the language long ago with ease. I want to thank customer service for their excellent service and answering all questions at any time.",
        ar: "إذا كان عندنا نفس كفاءة المعلمين ونفس قوة التواصل مع الطلاب ونفس الطريقة الشيقة للتعليم سواء للكبار أو الصغار لكان أولادنا تعلموا اللغة من زمان وبكل سلاسة وأحب أشكر خدمة العملاء على تعاملهم الراقي والرد على كل الأسئلة في أي وقت"
      },
      image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&q=80"
    },
    {
      id: 2,
      name: "Leena",
      text: {
        en: "First, I want to thank customer service for their patience and excellent treatment with customers. Even under pressure, they respond quickly. Honestly, in Canada English Life, my daughter has been with them for less than a month and she's learning to read and interact with Miss Gaby wonderfully. I honestly recommend everyone who wants to learn English to register with them.",
        ar: "أول شي حابة أشكر خدمة العملاء على سعة صدرهم وتعاملهم الراقي مع العملاء حتى مع الضغط يتجاوبوا معك ويردوا بسرعة وثانياً والله أقول رأي بكل صراحة في كندا إنجليش لايف بنتي معاهم أقل من شهر وما شاء الله صارت تتعلم تقرأ وتتفاعل مع مس غابي بطريقة ممتازة والله أنصح كل أحد حاب يتعلم إنجليزي يسجل عندهم"
      },
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80"
    },
    {
      id: 3,
      name: "Mohammed",
      text: {
        en: "Excellent academy with professional teachers. My English has improved significantly in just 3 months. The flexible schedule and online format make it easy to learn from anywhere.",
        ar: "أكاديمية ممتازة مع معلمين محترفين. تحسنت لغتي الإنجليزية بشكل كبير في 3 أشهر فقط. الجدول الزمني المرن والتنسيق عبر الإنترنت يجعل من السهل التعلم من أي مكان"
      },
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80"
    }
  ],

  // FAQ
  faq: [
    {
      id: 1,
      question: { en: "What ages are you accepting students?", ar: "ما هي الأعمار التي تقبلون الطلاب؟" },
      answer: { en: "We offer English Courses to all ages and all levels", ar: "نقدم دورات اللغة الإنجليزية لجميع الأعمار والمستويات" }
    },
    {
      id: 2,
      question: { en: "Do you offer bulk discounts?", ar: "هل تقدمون خصومات جماعية؟" },
      answer: { en: "Yes, we provide special discounts for bulk purchases. Contact Canada English Life for details.", ar: "نعم، نقدم خصومات خاصة للمشتريات بالجملة. اتصل بـ Canada English Life للحصول على التفاصيل" }
    },
    {
      id: 3,
      question: { en: "Do you have offer Approved Certificates upon successful completion?", ar: "هل تقدمون شهادات معتمدة عند الإكمال الناجح؟" },
      answer: { en: "Absolutely! All products from Canada English Life meet industry standards and are trusted by most institutions", ar: "بالتأكيد! جميع المنتجات من Canada English Life تلبي معايير الصناعة وموثوقة من قبل معظم المؤسسات" }
    },
    {
      id: 4,
      question: { en: "Are all your teachers Native English Speakers?", ar: "هل جميع المعلمين لديكم متحدثون أصليون للغة الإنجليزية؟" },
      answer: { en: "Most of our advanced levels English Courses are taught through our Native English Teachers, from Canada, USA and UK.", ar: "معظم دورات المستوى المتقدم يتم تدريسها من قبل معلمينا الناطقين باللغة الإنجليزية من كندا والولايات المتحدة والمملكة المتحدة" }
    },
    {
      id: 5,
      question: { en: "Can we request for refund after payment?", ar: "هل يمكننا طلب استرداد بعد الدفع؟" },
      answer: { en: "Unfortunately, All fees are non-refundable after payment has been made to any of our courses.", ar: "بالأسف، جميع الرسوم غير قابلة للاسترداد بعد إتمام الدفع لأي من دوراتنا" }
    }
  ],

  // Values
  values: [
    {
      id: 1,
      title: { en: "Innovative Software", ar: "برامج مبتكرة" },
      description: { en: "Fresh, creative English Learning solutions.", ar: "حلول إبداعية جديدة لتعلم اللغة الإنجليزية" },
      icon: "Lightbulb"
    },
    {
      id: 2,
      title: { en: "Integrity", ar: "النزاهة" },
      description: { en: "Honesty and transparency. Reliable Customer Service", ar: "الصدق والشفافية. خدمة عملاء موثوقة" },
      icon: "Shield"
    },
    {
      id: 3,
      title: { en: "Excellence", ar: "التميز" },
      description: { en: "Top-notch coordination services.", ar: "خدمات تنسيق من الدرجة الأولى" },
      icon: "Award"
    }
  ],

  // Quiz Questions
  quizQuestions: [
    {
      id: 1,
      question: {
        en: "How do you introduce yourself in English?",
        ar: "كيف تقدم نفسك باللغة الإنجليزية؟"
      },
      options: [
        {
          text: { en: "I am not able to introduce myself", ar: "لا أستطيع تقديم نفسي" },
          points: 0
        },
        {
          text: { en: "My name is... I am from...", ar: "اسمي... أنا من..." },
          points: 1
        },
        {
          text: { en: "Hello, I'm... I work as... Nice to meet you", ar: "مرحباً، أنا... أعمل كـ... سعيد بلقائك" },
          points: 2
        },
        {
          text: { en: "I'd like to introduce myself. I'm a professional with extensive experience in...", ar: "أود أن أقدم نفسي. أنا محترف ولدي خبرة واسعة في..." },
          points: 3
        }
      ]
    },
    {
      id: 2,
      question: {
        en: "Choose the correct sentence:",
        ar: "اختر الجملة الصحيحة:"
      },
      options: [
        {
          text: { en: "He don't like coffee", ar: "He don't like coffee" },
          points: 0
        },
        {
          text: { en: "He doesn't like coffee", ar: "He doesn't like coffee" },
          points: 2
        },
        {
          text: { en: "He not like coffee", ar: "He not like coffee" },
          points: 0
        },
        {
          text: { en: "He doesn't likes coffee", ar: "He doesn't likes coffee" },
          points: 1
        }
      ]
    },
    {
      id: 3,
      question: {
        en: "What is the past tense of 'go'?",
        ar: "ما هو الماضي من 'go'؟"
      },
      options: [
        {
          text: { en: "goed", ar: "goed" },
          points: 0
        },
        {
          text: { en: "went", ar: "went" },
          points: 2
        },
        {
          text: { en: "goes", ar: "goes" },
          points: 0
        },
        {
          text: { en: "going", ar: "going" },
          points: 0
        }
      ]
    },
    {
      id: 4,
      question: {
        en: "Complete: 'If I _____ rich, I would travel the world.'",
        ar: "أكمل: 'If I _____ rich, I would travel the world.'"
      },
      options: [
        {
          text: { en: "am", ar: "am" },
          points: 0
        },
        {
          text: { en: "was", ar: "was" },
          points: 1
        },
        {
          text: { en: "were", ar: "were" },
          points: 2
        },
        {
          text: { en: "be", ar: "be" },
          points: 0
        }
      ]
    },
    {
      id: 5,
      question: {
        en: "What does 'procrastinate' mean?",
        ar: "ماذا تعني كلمة 'procrastinate'؟"
      },
      options: [
        {
          text: { en: "To hurry", ar: "التسرع" },
          points: 0
        },
        {
          text: { en: "To delay or postpone", ar: "التأجيل أو التأخير" },
          points: 2
        },
        {
          text: { en: "To organize", ar: "التنظيم" },
          points: 0
        },
        {
          text: { en: "To celebrate", ar: "الاحتفال" },
          points: 0
        }
      ]
    },
    {
      id: 6,
      question: {
        en: "How comfortable are you with speaking English?",
        ar: "ما مدى راحتك في التحدث بالإنجليزية؟"
      },
      options: [
        {
          text: { en: "I can't speak at all", ar: "لا أستطيع التحدث على الإطلاق" },
          points: 0
        },
        {
          text: { en: "I can speak basic words and phrases", ar: "أستطيع التحدث بكلمات وعبارات أساسية" },
          points: 1
        },
        {
          text: { en: "I can have simple conversations", ar: "أستطيع إجراء محادثات بسيطة" },
          points: 2
        },
        {
          text: { en: "I can discuss complex topics fluently", ar: "أستطيع مناقشة مواضيع معقدة بطلاقة" },
          points: 3
        }
      ]
    },
    {
      id: 7,
      question: {
        en: "Choose the sentence with correct punctuation:",
        ar: "اختر الجملة ذات الترقيم الصحيح:"
      },
      options: [
        {
          text: { en: "Let's eat grandma", ar: "Let's eat grandma" },
          points: 0
        },
        {
          text: { en: "Let's eat, grandma", ar: "Let's eat, grandma" },
          points: 2
        },
        {
          text: { en: "Lets eat grandma", ar: "Lets eat grandma" },
          points: 0
        },
        {
          text: { en: "Let's eat grandma.", ar: "Let's eat grandma." },
          points: 0
        }
      ]
    },
    {
      id: 8,
      question: {
        en: "What is a synonym for 'happy'?",
        ar: "ما هو مرادف 'happy'؟"
      },
      options: [
        {
          text: { en: "Sad", ar: "Sad" },
          points: 0
        },
        {
          text: { en: "Joyful", ar: "Joyful" },
          points: 2
        },
        {
          text: { en: "Angry", ar: "Angry" },
          points: 0
        },
        {
          text: { en: "Tired", ar: "Tired" },
          points: 0
        }
      ]
    }
  ],

  // Quiz Results
  quizLevels: [
    {
      level: "Beginner",
      levelAr: "مبتدئ",
      minScore: 0,
      maxScore: 6,
      description: {
        en: "You're at the beginning of your English journey. Our beginner courses will help you build a strong foundation with basic vocabulary and grammar.",
        ar: "أنت في بداية رحلتك مع اللغة الإنجليزية. ستساعدك دوراتنا للمبتدئين على بناء أساس قوي مع المفردات والقواعد الأساسية."
      },
      recommendedCourses: [
        { id: 4, title: "Basic Level for Kids for One Month" },
        { id: 5, title: "Children's English Courses - Basic Level" },
        { id: 6, title: "General English Training for Level 1" }
      ],
      badge: "🌱",
      color: "from-green-400 to-emerald-500"
    },
    {
      level: "Intermediate",
      levelAr: "متوسط",
      minScore: 7,
      maxScore: 12,
      description: {
        en: "You have a good grasp of basic English! Our intermediate courses will help you improve your fluency and expand your vocabulary for everyday conversations.",
        ar: "لديك فهم جيد للغة الإنجليزية الأساسية! ستساعدك دوراتنا المتوسطة على تحسين طلاقتك وتوسيع مفرداتك للمحادثات اليومية."
      },
      recommendedCourses: [
        { id: 2, title: "Adults Course 5 months membership" },
        { id: 3, title: "Adults English Course (Group - All Levels)" }
      ],
      badge: "📚",
      color: "from-blue-400 to-cyan-500"
    },
    {
      level: "Advanced",
      levelAr: "متقدم",
      minScore: 13,
      maxScore: 24,
      description: {
        en: "Excellent! You have strong English skills. Our advanced courses including IELTS preparation will help you achieve fluency and professional-level communication.",
        ar: "ممتاز! لديك مهارات قوية في اللغة الإنجليزية. ستساعدك دوراتنا المتقدمة بما في ذلك إعداد الآيلتس على تحقيق الطلاقة والتواصل على المستوى المهني."
      },
      recommendedCourses: [
        { id: 1, title: "1 on 1 English Training" }
      ],
      badge: "🏆",
      color: "from-amber-400 to-orange-500"
    }
  ]
};
